import buildInfo from "virtual:build-info";
import styles from "./Footer.module.css";

const hostname = window.location.hostname;
const isLocalhost = hostname.includes("localhost");
const isProd = !hostname.includes(".dev") && !isLocalhost;
// Only the deployed dev site is tagged "dev"; on localhost the "(local)" build
// marker already implies a non-prod environment, so we don't repeat it.
const envLabel = isProd || isLocalhost ? "" : "dev";

export function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className={styles.footer}>
            <div className={styles.brand}>Most Commercial Combinations</div>
            <div className={styles.meta}>
                © {year} Ingka Group
            </div>
            <div className={`${styles.meta} ${styles.dim}`}>
                Version {buildInfo.sha}{buildInfo.local ? " (local)" : ""}, {buildInfo.datetime}
                {envLabel ? ` · ${envLabel}` : ""}
            </div>
        </footer>
    );
}
